import { render, staticRenderFns } from "./editOriginal.vue?vue&type=template&id=755cc3d7&"
import script from "./editOriginal.vue?vue&type=script&lang=js&"
export * from "./editOriginal.vue?vue&type=script&lang=js&"
import style0 from "./editOriginal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports